import React from 'react';
import SectionContainer from 'components/Containers/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import HeadTextSection from 'components/HeadTextSection';
import Disclaimer from 'components/AdvertiserToolTip';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import RowGrid from 'components/Containers/RowGrid';
import { StandardCreditCardOffer } from 'components/Offers/StandardCreditCardOffer/StandardCreditCardOffer';
import { MARKETPLACE_BUSINESS_OFFERS } from 'types/morph.pagePosition.constants';
import { OfferModuleWrapper } from 'partial/OfferModuleWrapper/OfferModuleWrapperController';

const SuggestedBusinessCCLoansView = props => {
  const { offers, seenPixel, modulePosition, isOfferError } = props;
  return (
    <>
      {seenPixel}
      <HeadTextSection
        sectionTitle="Get a little extra support"
        sectionParagraph="Business credit cards often come with higher credit limits because
        your personal income and business revenue are both considered."
      />
      <OfferModuleWrapper isOfferError={isOfferError}>
        <Row fullWidth>
          <Disclaimer showPartnerText />
        </Row>
        <SectionContainer className="sectionContainer m-padLR0 margT8 m-padTB24">
          <div className="text-28 bold margB24 m-text-20 m-margB16 padLR48 m-padLR16">
            Your Suggested Cards
          </div>
          <RowGrid isOnlyMobile>
            <StaticOfferContainer
              {...props}
              offerMetadataList={offers}
              creditCardTemplate={StandardCreditCardOffer}
              pagePosition={MARKETPLACE_BUSINESS_OFFERS}
              modulePosition={modulePosition}
              classNameOverwrite={{
                ccOfferContainer: 'margB16 maxWidth100',
              }}
            />
          </RowGrid>
        </SectionContainer>
      </OfferModuleWrapper>
    </>
  );
};

export default SuggestedBusinessCCLoansView;
